import { useMutation, useQueryClient } from '@tanstack/react-query';

import { createQueryDefinition, createQueryHook } from 'common/services/queryBuilder';

import { listTrials, createTrial, extendTrial, upgradeTrial } from './services';

export const TrialsListQueryKey = createQueryDefinition(
  (search, query) => ['managemobi', 'trials', 'list', search, query],
  ({ queryKey: [, , , search, query] }) => listTrials({ search, ...query }),
);

export const useTrialsListQuery = createQueryHook(TrialsListQueryKey, {
  select: ({ data, meta }) => ({ data, meta }),
});

export const useCreateTrialMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: data => createTrial(data),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['managemobi', 'trials', 'list'],
      });
    },
  });
};

// Extend trial mutation
export const useExtendTrialMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: data => extendTrial(data),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['managemobi', 'trials', 'list'],
      });
    },
  });
};

// Upgrade trial mutation
export const useUpgradeTrialMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: data => upgradeTrial(data),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['managemobi', 'trials', 'list'],
      });
    },
  });
};
